import { styled } from "goober";
import { useComposerStrip } from "../../hooks/useComposerStrip";
import { playClick } from "../../lib/sounds";
import { Icon } from "../Icon";

const Hint = styled("span")`
  display: flex;
  position: relative;
  top: 4px;
  color: var(--text-secondary);
  opacity: 0;
  transform: translateY(4px);
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
`;

const Spacer = styled("div")`
  flex: 1;
  align-self: stretch;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover ${Hint} {
    opacity: 0.3;
    transform: translateY(0);
  }
`;

export function ComposerStripToggle() {
  const { open, toggle } = useComposerStrip();
  return (
    <Spacer
      onMouseDown={(e) => {
        if (e.button !== 0) return;
        e.preventDefault();
        playClick();
        toggle();
      }}
    >
      <Hint>
        <Icon
          name="chevron-up"
          size={16}
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        />
      </Hint>
    </Spacer>
  );
}
